import * as React from "react";

export interface ListPageProps {
  /**
   * Page title. Accepts a plain string OR a `ReactNode` so callers can pass
   * an i18n-resolving wrapper (e.g. `<TranslatedText id="fleet.machine" />`)
   * without forcing the page-factory to do server-side translation lookups.
   */
  title: React.ReactNode;
  description?: React.ReactNode;
  primaryAction?: React.ReactNode;
  filters?: React.ReactNode;
  /** The list/table content (Plan UI-3 will provide a real engine) */
  children: React.ReactNode;
  /** Pagination or footer */
  footer?: React.ReactNode;
}

export function ListPage({ title, description, primaryAction, filters, children, footer }: ListPageProps) {
  return (
    <div className="space-y-6">
      <header className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
        <div>
          <h1 className="text-2xl font-semibold tracking-tight">{title}</h1>
          {description ? <p className="mt-1 text-sm text-fg-muted">{description}</p> : null}
        </div>
        {primaryAction}
      </header>
      {filters ? <div className="rounded-md border border-border bg-bg-subtle p-3">{filters}</div> : null}
      <div>{children}</div>
      {footer ? <div className="border-t border-border pt-4">{footer}</div> : null}
    </div>
  );
}
